export default {
  create (config) {
    this.config = config
    this.fields = this._flatten(config)
    return this
  },
  setData (body) {
    this.fields = body
  },
  _flatten (config) {
    let fields = {}
    Object.keys(config).forEach(key => {
      config[key].forEach(f => {
        fields[f.name] = ''
      })
    })
    return fields
  }
}



// WEBPACK FOOTER //
// ./src/Form.js